<template>
  <div class="tm-selectors-container">
    
    <div class="selector-wrapper" v-click-outside="closeCountry">
      <div class="selector" @click="toggleCountry">
        <img height="40" width="40" alt="Countries" class="selector-image" src="https://tmsi.akamaized.net/breadcrumb/bc-countries.svg">
        <div class="selector-title">
          <span class="arrow arrow-down">{{ selectedCountry ? selectedCountry.name : 'Country' }}</span>
        </div>
        <button class="forward-button">»</button>
      </div>
      
      <div class="tm-dropdown-menu dropdown-country" v-if="showCountryDropdown">
        <div class="search-box">
          <input type="text" placeholder="Search..." v-model="countrySearch" ref="countryInput">
        </div>
        <div style="font-size: 12px; color: #888; padding: 4px 8px; background: #eee;">
          Найдено: {{ filteredCountries.length }}
        </div>
        
        <ul class="dropdown-list">
          <li v-for="(country, index) in filteredCountries" :key="'country-' + index" @click="selectCountry(country)">
            {{ country.name }}
          </li>
        </ul>
      </div>
    </div>

    <div class="selector-wrapper" v-if="selectedCountry" v-click-outside="closeLeague">
      <div class="selector" @click="toggleLeague">
        <img height="40" width="40" alt="Competitions" class="selector-image" src="https://tmsi.akamaized.net/breadcrumb/bc-competitions.svg">
        <div class="selector-title">
          <span class="arrow arrow-down">{{ selectedLeague ? selectedLeague.name : 'Competition' }}</span>
        </div>
        <button class="forward-button" :class="{'is-loading': isLoading}" @click.stop="triggerLoadMatches">»</button>
      </div>

      <div class="tm-dropdown-menu dropdown-league" v-if="showLeagueDropdown">
        <div class="search-box">
          <input type="text" placeholder="Search..." v-model="leagueSearch" ref="leagueInput">
        </div>
        <div style="font-size: 12px; color: #888; padding: 4px 8px; background: #eee;">
          Найдено: {{ filteredLeagues.length }}
        </div>
        <ul class="dropdown-list">
          <li v-for="(league, index) in filteredLeagues" :key="'league-' + index" @click="selectLeague(league)">
            {{ league.name }}
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import { countriesData } from "../assets/leaguesData.js"; 

export default {
  name: "TmSelectors",
  data() {
    return {
      countries: countriesData || [],
      selectedCountry: null,
      selectedLeague: null,
      
      showCountryDropdown: false,
      showLeagueDropdown: false,
      
      countrySearch: "",
      leagueSearch: "",
      
      isLoading: false // Флаг для запуска анимации
    };
  },
  computed: {
    filteredCountries() {
      const list = this.countries || [];
      if (!this.countrySearch) return list;
      
      const query = this.countrySearch.toLowerCase();
      return list.filter(c => c && c.name && c.name.toLowerCase().includes(query));
    },
    filteredLeagues() {
      if (!this.selectedCountry || !this.selectedCountry.leagues) return [];
      const list = this.selectedCountry.leagues;
      if (!this.leagueSearch) return list;
      
      const query = this.leagueSearch.toLowerCase();
      return list.filter(l => l && l.name && l.name.toLowerCase().includes(query));
    }
  },
  methods: {
    toggleCountry() {
      this.showCountryDropdown = !this.showCountryDropdown;
      this.showLeagueDropdown = false;
      if (this.showCountryDropdown) {
        this.$nextTick(() => {
          if (this.$refs.countryInput) this.$refs.countryInput.focus();
        });
      }
    },
    toggleLeague() {
      this.showLeagueDropdown = !this.showLeagueDropdown;
      this.showCountryDropdown = false;
      if (this.showLeagueDropdown) {
        this.$nextTick(() => {
          if (this.$refs.leagueInput) this.$refs.leagueInput.focus();
        });
      }
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.selectedLeague = null; 
      this.countrySearch = "";
      this.showCountryDropdown = false;
      
      this.showLeagueDropdown = true;
      this.$nextTick(() => {
        if (this.$refs.leagueInput) this.$refs.leagueInput.focus();
      });
    },
    selectLeague(league) {
      this.selectedLeague = league;
      this.leagueSearch = "";
      this.showLeagueDropdown = false;
      
      this.$emit('league-selected', league, this.selectedCountry); 
    },
    closeCountry() {
      this.showCountryDropdown = false;
    },
    closeLeague() {
      this.showLeagueDropdown = false;
    },
    triggerLoadMatches() {
      if (this.selectedLeague) {
        // === ЗАПУСК АНИМАЦИИ ===
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
        }, 600); // Анимация длится 600мс, затем отключается

        this.$emit('load-matches', this.selectedLeague);
      } else {
        alert("Сначала выберите лигу!");
      }
    }
  },
  directives: {
    clickOutside: {
      bind(el, binding) { 
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) { 
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style scoped>
.tm-selectors-container {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.selector-wrapper {
  position: relative;
  margin-right: 2px;
}

.selector {
  display: flex;
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  height: 40px;
  border: 1px solid #ccc;
}

.selector-image {
  height: 40px;
  width: 40px;
  background-color: #002d5a;
}

.selector-title {
  padding: 0 15px;
  color: #002d5a;
  font-weight: bold;
  min-width: 120px;
  font-size: 14px;
}

/* === СТИЛИ КНОПКИ ЗАГРУЗКИ И АНИМАЦИЙ === */
.forward-button {
  background: #f2f2f2;
  border: none;
  border-left: 1px solid #ccc;
  height: 40px;
  width: 30px;
  cursor: pointer;
  color: #1a8ccb;
  font-size: 18px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.forward-button:hover {
  background-color: #e6f2f9;
  color: #005f90;
}

/* Эффект физического вдавливания при клике мышкой */
.forward-button:active {
  transform: scale(0.85); 
  background-color: #d0e4f2;
}

/* Класс, который вешается скриптом на 600мс */
.forward-button.is-loading {
  animation: pulse-success 0.6s ease-in-out;
}

/* Сама анимация (увеличение и подсветка зеленым цветом) */
@keyframes pulse-success {
  0% {
    transform: scale(1);
    background-color: #e6f2f9;
  }
  30% {
    transform: scale(1.2);
    background-color: #28a745; /* Зеленый цвет успешного нажатия */
    color: white;
  }
  100% {
    transform: scale(1);
    background-color: #f2f2f2;
  }
}

.tm-dropdown-menu {
  position: fixed; 
  top: 55px; 
  width: 250px;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 999999 !important; 
}

.dropdown-country {
  margin-left: 0px; 
}

.dropdown-league {
  margin-left: 0px; 
}

.search-box {
  padding: 8px;
  background: #f2f2f2;
  border-bottom: 1px solid #ccc;
}

.search-box input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  color: #000;
}

.dropdown-list {
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 350px;
  overflow-y: auto;
  background: #fff;
  text-align: left;
}

.dropdown-list li {
  display: block;
  padding: 8px 12px;
  color: #1a8ccb;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 1px solid #f2f2f2;
}

.dropdown-list li:hover {
  background-color: #e6f2f9;
  text-decoration: underline;
}
</style>